// Two-sided communities (e.g. hospitals ↔ doctors): one profile question is
// marked `side: true` ("I am…": 'A hospital or trust' / 'A doctor'), and
// questions marked `forSide: '<answer>'` are only for members who gave that
// answer. Suggestions only ever pair members on different sides (backend
// GetUsersToMatch / MatchingForSingleUserV1). Communities without a side
// question are unaffected.

export const sideFieldOf = (schema) => Object.keys(schema || {}).find((k) => schema[k]?.side === true) || null;

// The questions to show this member, given their answers so far: everything
// not tied to a side, plus their own side's questions once they've picked
// one. The side question itself first.
export const fieldsForMember = (schema, profile) => {
  const keys = Object.keys(schema || {});
  const sideField = sideFieldOf(schema);
  if (!sideField) return keys;
  const side = profile?.[sideField];
  const shown = keys.filter((k) => !schema[k]?.forSide || schema[k].forSide === side);
  return [sideField, ...shown.filter((k) => k !== sideField)];
};
